import React from "react";
import PatientAppointment from "../../components/PatientAppointment";
import styles from "./Appointment.module.css";

function AppointmentsContainer({ appointments }) {

  return (
    <div className={styles["appointment-container"]}>
      <div className={styles["text-calendar-container"]}>
        <div className={styles["appointments-title"]}>Upcoming Appointments</div>
        <div className={styles["appointments-upcoming"]}></div>
      </div>
      <div className={styles["patient-appointment-container"]}>
        <PatientAppointment appointments={appointments} />
      </div>
    </div>
  );
}

export default AppointmentsContainer;
